import { Box, Button, Divider, Fade, makeStyles, Paper, Popper, Typography, useMediaQuery } from "@material-ui/core";
import clsx from "clsx";
import { useSnackbar } from "notistack";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import travaLogo from "src/assets/images/tokens/travas.png";
import ViewAccountAddressOnBSC from "src/components/BscExplorer/ViewAccountAddressOnBSC";
import TextCopyButton from "src/components/button/TextCopyButton";
import { ExternalLink, Wallet } from "src/components/icons";
import useTravaBalance from "src/hooks/use-trava-balance.js";
import { formatAddress, isNumeric, numberWithCommas } from "src/utils";
import { disconnectWallet } from "src/wallet-connection/handle-connection";

const useStyles = makeStyles((theme) => ({
  paperRoot: {
    padding: theme.spacing(2),
    marginTop: theme.spacing(1),
    minWidth: 200,
  },
  popper: {
    zIndex: theme.zIndex.modal,
  },
  imgCoin: {
    width: 46,
    height: 46,
    borderRadius: "50%",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    backgroundColor: theme.palette.common.white,
  },
  button: {
    border: 0,
    textTransform: "capitalize",
    padding: theme.spacing(1.2, 1),
    // minWidth: (props) => (props.minimizeUI ? "100px" : "163px"),
    background: "linear-gradient(100.42deg, #2C85EE 16.07%, #4FB5FF 79.2%)",
  },
  fiberIcon: {
    fontSize: 10,
    verticalAlign: "middle",
    marginRight: 2,
    color: "#01C514",
  },
  balanceValue: {
    fontWeight: 500,
    fontSize: "14px",
  },
  btn: {
    padding: theme.spacing(0),
    textTransform: "unset",
    fontWeight: 400,
    display: "flex",
    alignItems: "baseline",
    "&:hover": {
      backgroundColor: "transparent",
      color: theme.palette.primary.main,
    },
  },
  btnBuyTrava: {
    "&:hover": {
      textDecoration: "underline",
    },
  },
  buyTravaLink: {
    textDecoration: "none",
  },
  viewOnBSCLink: {
    color: "inherit",
    textDecoration: "none",
    verticalAlign: "-2px",
  },
}));

export default function AccountPopper() {
  const cls = useStyles();
  const dispatch = useDispatch();
  const { enqueueSnackbar } = useSnackbar();
  const [anchorEl, setAnchorEl] = useState(null);
  const { travaBalance, rTravaBalance } = useTravaBalance();
  const accountAddress = useSelector((state) => state.accountSlice.address);
  const open = Boolean(anchorEl);
  const id = open ? "account-popper" : undefined;
  const xsOnly = useMediaQuery((theme) => theme.breakpoints.only("xs"));

  useEffect(() => {
    window.addEventListener("click", handleWindowClick);
    return () => window.removeEventListener("click", handleWindowClick);
  }, []);

  function handleWindowClick() {
    setAnchorEl(null);
  }

  function handleClickBtn(ev) {
    ev.stopPropagation();
    setAnchorEl(anchorEl ? null : ev.currentTarget);
  }

  function handleDisconnectWallet() {
    disconnectWallet(dispatch, enqueueSnackbar);
  }

  return (
    <>
      <Button aria-describedby={id} size="small" className={cls.button} variant="outlined" onClick={handleClickBtn}>
        <Box display="flex" alignItems="center">
          <Wallet size={22} />
          <Box pl={1.5} display="flex" alignItems="center">
            <span style={{ fontSize: 15, lineHeight: 0 }}>
              {xsOnly ? `${accountAddress.slice(0, 5)}...` : formatAddress(accountAddress)}
            </span>
          </Box>
        </Box>
      </Button>
      <Popper id={id} open={open} anchorEl={anchorEl} transition placement="bottom-end" className={cls.popper}>
        {({ TransitionProps }) => (
          <Fade {...TransitionProps} timeout={350}>
            <Paper elevation={1} className={cls.paperRoot} onClick={(ev) => ev.stopPropagation()}>
              <Box display="flex" alignItems="center">
                <Typography variant="body2">{formatAddress(accountAddress)}</Typography>
                <TextCopyButton text={accountAddress} tooltipTitle={"Copy account address"} />
                <ViewAccountAddressOnBSC address={accountAddress} />
              </Box>
              <Box display="flex" alignItems="center" pt={1} pb={2}>
                <Box className={cls.imgCoin} mr={1}>
                  <img width={27} src={travaLogo} alt="" />
                </Box>
                <Box>
                  <Typography variant="body2" color="textSecondary">
                    Balance
                  </Typography>
                  <Typography variant="body2" className={cls.balanceValue}>
                    {isNumeric(travaBalance) ? numberWithCommas(Number(parseFloat(travaBalance).toFixed(2))) : "---"}
                    &nbsp;TRAVA
                  </Typography>
                  <Typography variant="body2" className={cls.balanceValue}>
                    {isNumeric(rTravaBalance) ? numberWithCommas(Number(parseFloat(rTravaBalance).toFixed(2))) : "---"}
                    &nbsp;rTrava&nbsp;
                    <a
                      target="_blank"
                      rel="noopener noreferrer"
                      className={cls.viewOnBSCLink}
                      href={"https://app.trava.finance/staking/vaults"}
                    >
                      <ExternalLink size={12} />
                    </a>
                  </Typography>
                </Box>
              </Box>
              <Divider />
              <Box pt={1}>
                <a
                  href="https://pancakeswap.finance/swap?outputCurrency=0x0391bE54E72F7e001f6BBc331777710b4f2999Ef"
                  target="_blank"
                  rel="noopener noreferrer"
                  className={cls.buyTravaLink}
                >
                  <Button className={clsx(cls.btn, cls.btnBuyTrava)}>
                    Buy TRAVA &nbsp; <ExternalLink size={15} />
                  </Button>
                </a>
              </Box>
              <Box>
                <Button className={cls.btn} onClick={handleDisconnectWallet}>
                  Disconnect
                </Button>
              </Box>
            </Paper>
          </Fade>
        )}
      </Popper>
    </>
  );
}
